/**
 * Initializes the cookie consent widget for GDPR compliance.
 * @returns {void}
 */
function cookieConsentWidget() {
    const cookieName = '__cookie_consent';
    const cookieIdSelector = '__shopwired_consent_cookie_container';
    const declineCookieName = cookieName + '_declined';
    const container = document.getElementById(cookieIdSelector);
    if (!container) {
        return;
    }
    // noinspection RegExpRedundantEscape
    if (!decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(declineCookieName).replace(/[\-\.\+\*]/g, "\\{replace64}amp;") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1"))) {
        container.style.display = 'block';
    }
    const acceptButtonSelector = '__shopwired_consent_cookie_accept';
    const acceptButton = document.getElementById(acceptButtonSelector);
    if (acceptButton) {
        // noinspection DuplicatedCode
        acceptButton.addEventListener('click', function () {
            const date = new Date();
            date.setTime(date.getTime() + (30 * 24 * 3600 * 1000));
            document.cookie = cookieName + '=1; expires=' + date.toUTCString() + '; path=/';
            //container.remove();
            container.parentNode.removeChild(container);
            location.reload();
        });
    }
    const closeButtonSelector = '#__shopwired_consent_cookie_close';
    const closeButton = document.getElementById(closeButtonSelector);
    if (closeButton) {
        closeButton.addEventListener('click', function () {
            document.cookie = declineCookieName + '=1; path=/';
            //container.remove();
            container.parentNode.removeChild(container);
        });
    }
}

export {cookieConsentWidget};
